"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormError = exports.Form = void 0;
const styles_1 = __importDefault(require("../Typography/styles"));
const activeLabelStyles = {
    transform: 'scale(0.85) translateY(-24px)',
};
const formVariants = {
    floating: {
        container: {
            _focusWithin: {
                label: Object.assign(Object.assign({}, activeLabelStyles), { color: 'gray.600' }),
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label': Object.assign({}, activeLabelStyles),
            label: {
                top: 0,
                left: 0,
                zIndex: 2,
                position: 'absolute',
                backgroundColor: 'white',
                pointerEvents: 'none',
                textColor: 'gray.800',
                mx: 3,
                px: 1,
                my: 1.5,
                py: 1.5,
                transformOrigin: 'left top',
            },
        },
    },
};
const FormStyle = {
    variants: formVariants,
};
exports.Form = FormStyle;
const formErrorVariants = Object.fromEntries(Object.entries(styles_1.default.variants).map(([variant, styles]) => [variant, { text: styles }]));
const FormErrorStyle = {
    baseStyle: {
        text: Object.assign(Object.assign({}, styles_1.default.baseStyle), { fontWeight: '400', color: 'red.400', mt: 0.5 }),
    },
    variants: formErrorVariants,
    defaultProps: {
        variant: 'body3',
    },
};
exports.FormError = FormErrorStyle;
